import { MGPOptional, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { Coord3D } from '../../jscaip/Coord3D';
export class PylosCoord extends Coord3D {
    static coordEncoder = Coord3D.getCoord3DEncoder(PylosCoord.of);
    static optionalEncoder = MGPOptional.getEncoder(PylosCoord.coordEncoder);
    static of(x, y, z) {
        return new PylosCoord(x, y, z);
    }
    constructor(x, y, z) {
        super(x, y, z);
        Utils.assert(0 <= x && x <= 3, `PylosCoord: Invalid X: ${x}.`);
        Utils.assert(0 <= y && y <= 3, `PylosCoord: Invalid Y: ${y}.`);
        Utils.assert(0 <= z && z <= 3, `PylosCoord: Invalid Z: ${z}.`);
        const floorSize = 4 - z;
        Utils.assert(this.isInRange(floorSize, floorSize), this.toString() + ' is not in range.');
    }
    toString() {
        return 'PylosCoord' + this.toShortString();
    }
    getLowerPieces() {
        if (this.z === 0)
            throw new Error(`PylosCoord: floor pieces don't have lower pieces.`);
        const lowerZ = this.z - 1;
        const upLeft = new PylosCoord(this.x, this.y, lowerZ);
        const upRight = new PylosCoord(this.x + 1, this.y, lowerZ);
        const downLeft = new PylosCoord(this.x, this.y + 1, lowerZ);
        const downRight = new PylosCoord(this.x + 1, this.y + 1, lowerZ);
        return [upLeft, upRight, downLeft, downRight];
    }
    getHigherCoords() {
        if (this.z === 3)
            throw new Error(`Top piece don't have lower pieces.`);
        const higherZ = this.z + 1;
        const upLeft = new Coord(this.x - 1, this.y - 1);
        const upRight = new Coord(this.x, this.y - 1);
        const downLeft = new Coord(this.x - 1, this.y);
        const downRight = new Coord(this.x, this.y);
        const levelSize = 4 - higherZ;
        return [upLeft, upRight, downLeft, downRight]
            .filter((coord) => coord.isInRange(levelSize, levelSize))
            .map((c) => new PylosCoord(c.x, c.y, higherZ));
    }
    getNextValid(dir) {
        const xyNext = new Coord(this.x, this.y).getNext(dir);
        const floorSize = 4 - this.z;
        if (xyNext.isNotInRange(floorSize, floorSize)) {
            return MGPOptional.empty();
        }
        else {
            return MGPOptional.of(new PylosCoord(xyNext.x, xyNext.y, this.z));
        }
    }
}
